import script from "./ShareLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareLink.vue?vue&type=script&setup=true&lang=js"

import "./ShareLink.vue?vue&type=style&index=0&id=6fe48ef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe48ef8"]])

export default __exports__